import { z } from 'zod';
import { request, useQuery } from '@applyboard/ui-utils';

export const GET_LOAN_TEMPLATES_URL = '/api/loans/v2/applications/templates';

const LoanTemplateRepresentationSchema = z.object({
  id: z.string(),
  name: z.string(),
  fields: z.array(
    z.object({
      type: z.string(),
      value: z.string(),
      label: z.string(),
    }),
  ),
});

const LoanTemplatesResponseSchema = z.object({
  templates: z.array(LoanTemplateRepresentationSchema),
});

export type GetLoanTemplatesResponse = z.infer<typeof LoanTemplatesResponseSchema>;

export function useGetLoanTemplates() {
  const { data, isFetching, isFetched, error } = useQuery(['get_loan_templates'], async () => {
    return request<GetLoanTemplatesResponse>(GET_LOAN_TEMPLATES_URL, {
      schema: LoanTemplatesResponseSchema,
    });
  });

  const loanTemplates = (data?.templates ?? []).map(template => {
    return {
      id: template.id,
      name: template.name,
      fields: template.fields.map(field => {
        return {
          type: field.type,
          value: field.value,
          label: field.label,
        };
      }),
    };
  });

  return {
    loanTemplates: loanTemplates,
    hasError: error,
    isFetchingLoanTemplates: isFetching,
    isFetchedLoanTemplates: isFetched,
  };
}
